<div class="container-main container-fluid overflow-x-hidden mt-4 mb-4 " id="contactus">
  <div class="main_header mt-5 mb-5">
    Contact Us
  </div>
  <div class="row align-items-center g-3 g-lg-5 ">
    <div class=" col-12 col-lg-6 mb-4 mb-lg-0">
      <img src="../../assets/images/contactus.jpeg" class="img  rounded shadow-sm"
        alt="Illustration of people collaborating" style="max-height: 600px; width: 100%; object-fit: cover;">
    </div>
    <div class=" col-lg-6 align-content-center justify-content-center">
      <div class="card shadow border-0 mb-3">
        <div class="card-body p-3 p-md-4 p-lg-7">
          <h2 class="fw-bold mb-3 text-center  mainHeading">Let’s connect and build something great together</h2>
          <!-- <p class="text-muted mb-2 description">You can reach us anytime via the details below or fill out the form to
            get started.</p> -->
          <!--
          <div
            class="d-flex flex-column flex-sm-row flex-wrap justify-content-center justify-content-lg-start gap-2 gap-sm-4 mb-4 border-bottom pb-3 contact-info">
            <div class="address text-center text-sm-start">
              <a href="mailto:info@propertybox.co.in" class="text-decoration-none text-muted small">
                <fa-icon [icon]="faMail" class="icons me-1"></fa-icon> info&#64;propertybox.co.in
              </a>
            </div>
            <div class="address text-center text-sm-start">
              <a href="tel:+919666651067" class="text-decoration-none text-muted small">
                <fa-icon [icon]="faPhone" class="icons me-1"></fa-icon> ‎(+91) 96666 51067
              </a>
            </div>
          </div> -->


          <form [formGroup]="contactUsForm" novalidate class="container d-flex p-3 flex-column justify-content-end  ">
            <div class="mb-3">
              <app-input-filed label="Name" placeholder="Enter Name"
                [control]="$any(contactUsForm).controls['name']"></app-input-filed>
              <div class="errorText"
                *ngIf="contactUsForm.controls['name'].invalid && (contactUsForm.controls?.['name']?.dirty || contactUsForm.controls['name'].touched)">
                <div *ngIf="contactUsForm.controls['name'].errors?.['required']">
                  <small class="text-danger"> Name is required</small>
                </div>
              </div>
            </div>
            <div class="mb-3 ">
              <app-input-filed label="Email" placeholder="Enter Email"
                [control]="$any(contactUsForm).controls['email']"></app-input-filed>
              <div class="errorText"
                *ngIf="contactUsForm.controls['email'].invalid && (contactUsForm.controls?.['email']?.dirty || contactUsForm.controls['email'].touched)">
                <div *ngIf="contactUsForm.controls['email'].errors?.['pattern']">
                  <small class="text-danger">Please enter valid email</small>
                </div>
                <div *ngIf="contactUsForm.controls['email'].errors?.['required']">
                  <small class="text-danger"> Email is required</small>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <app-input-filed label="Mobile Number" placeholder="Enter 10 digit mobile number"
                [control]="$any(contactUsForm).controls['phoneNumber']" [allowedType]="'number'"
                [maxDigits]="10"></app-input-filed>
              <div class="errorText mt-1 ps-1"
                *ngIf="contactUsForm.controls['phoneNumber'].invalid && (contactUsForm.controls?.['phoneNumber']?.dirty || contactUsForm.controls['phoneNumber'].touched)">
                <div *ngIf="contactUsForm.controls['phoneNumber'].errors?.['pattern']">
                  <small class="text-danger">Please enter a valid mobile number</small>
                </div>
                <div *ngIf="contactUsForm.controls['phoneNumber'].errors?.['required']">
                  <small class="text-danger">Mobile number is required</small>
                </div>
              </div>
            </div>
            <div *ngIf="errorMessage" class="alert alert-danger text-center small py-2" role="alert">
              {{ errorMessage }}
            </div>
            <div class="move-button col-12 col-md-8 col-lg-6  d-flex justify-content-center mx-auto">
              <app-common-button buttonLabel="Continue" buttonClass="smaiifilledbutton"
                (clickEvent)="addContactusDetails()"></app-common-button>
            </div>
            <div *ngIf="message" class="alert alert-success text-center small py-2 mt-3" role="alert">
              {{message}}
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="mt-1 Outer container-fluid ">
  <div class="container-fluid p-0 m-0">
    <div class="row  inner">
      <div class="col-12" style="position: relative;">
        <div class="position-absolute p-3 bg-white m-3 shadow-sm custom-map-info-box rounded">
          <div class="row mb-2 align-items-start">
            <h4 class="text-center text-bold text-secondary">Bangalore</h4>
            <div class="fw-bold  ">Address</div>
            <div class=" text-secondary justify-text">
              Property Box India Private Limited, No. 25, 1 st Floor, Shankara Park
              Road, Shankarapuram, Bangalore- 560004.
            </div>
          </div>
          <div class="row mb-2 align-items-center">
            <div class="col-sm-3 col-12 fw-bold text-sm-end">
              Email
            </div>
            <div class="col-sm-9 col-12 text-secondary">
              <a href="mailto:info@propertybox.co.in" class="text-secondary">
                info&#64;propertybox.co.in
              </a>
            </div>
          </div>
          <div class="row align-items-center">
            <div class="col-sm-3 col-12 fw-bold text-sm-end">
              Phone
            </div>
            <div class="col-sm-9 col-12 text-secondary">
              <a href="tel:+91 90638 38825" class="text-secondary">
                +91 90638 38825
              </a>
            </div>
          </div>
        </div>
        <div class="position-absolute p-3 bg-white m-3 shadow-sm custom-map-info-box2 rounded">
          <div class="row mb-2 align-items-start">
             <h4 class="text-center text-bold text-secondary">Hyderabad</h4>
            <strong class="fw-bold  ">Address</strong>
            <div class=" text-secondary justify-text">
              502, 5th Floor, Saga City Heights, Kavuri Hills Rd, Behind Maharaja
              Chat, Sri Rama Colony, Madhapur, Hyderabad, Telangana 500081.
            </div>
          </div>
          <div class="row mb-2 align-items-center">
            <div class="col-sm-3 col-12 fw-bold text-sm-end">
              Email
            </div>
            <div class="col-sm-9 col-12 text-secondary">
              <a href="mailto:info@propertybox.co.in" class="text-secondary">
                info&#64;propertybox.co.in
              </a>
            </div>
          </div>
          <div class="row align-items-center">
            <div class="col-sm-3 col-12 fw-bold text-sm-end">
              Phone
            </div>
            <div class="col-sm-9 col-12 text-secondary">
              <a href="+91 90638 38825" class="text-secondary">
                +91 90638 38825
              </a>
            </div>
          </div>
        </div>
        <div class="mapcont">
          <google-map height="520px" width="100%" class="map12" [center]="center" [zoom]="zoom" [options]="mapOptions">
            <map-marker [position]="markerPosition1" [title]="markerTitle1">
            </map-marker>
            <map-marker [position]="markerPosition2" [title]="markerTitle2">
            </map-marker>
          </google-map>
        </div>
      </div>
    </div>
  </div>
</div>
